module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '.mobile-group')))]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24,
      "md": 18,
      "lg": 12
    }
  }, [_c('data-form', {
    attrs: {
      "model": "mobile-groups",
      "entity": _vm.mobileGroup,
      "fields": _vm.fields,
      "beforeSubmit": _vm.beforeSubmit,
      "after-submit": _vm.afterSubmit
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('related-mobiles')))]), _vm._v(" "), _c('data-table', {
    attrs: {
      "model": "mobiles",
      "columns": ['contact_name'],
      "isSelected": _vm.isMobileSelected
    },
    on: {
      "selection-change": _vm.mobileSelectChanged
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22ccd583!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile-group/MobileGroupDetails.vue
// module id = 1131
// module chunks = 2